import { PropsWithChildren } from 'react'
import { MaasOidcSecure } from '@maas-tools/auth-oidc'
import { useGetOidcSecureExtrasFromUrl } from 'common/hooks/maasOidcHelpers'
import { LeadsAccountSellersProvider } from 'containers/LeadsAccountSellersProvider'

export const ProtectedPageProviders = ({ children }: PropsWithChildren<unknown>) => {
  const oidcSecureExtras = useGetOidcSecureExtrasFromUrl()

  return (
    <MaasOidcSecure extras={oidcSecureExtras}>
      <LeadsAccountSellersProvider>{children}</LeadsAccountSellersProvider>
    </MaasOidcSecure>
  )
}
